document.addEventListener('DOMContentLoaded', () => {
  enhanceExistingSliders();
  initializePopupSliders();
});

function enhanceExistingSliders() {
  const sliders = document.querySelectorAll('slider-component');
  sliders.forEach(slider => {
    enhanceSliderWithAutoplay(slider);
  });
}

function enhanceSliderWithAutoplay(slider) {
  const sliderList = slider.querySelector('ul');
  if (!sliderList) return;

  const isAutoplayEnabled = sliderList.dataset.autoplay === 'true' || sliderList.dataset.autoplay === '1';
  const autoplaySpeed = parseInt(sliderList.dataset.speed) || 4000;
  const sliderItems = slider.querySelectorAll('li');
  const itemsPerScroll = parseInt(sliderList.dataset.itemsPerScroll) || 1;
  
  if (!isAutoplayEnabled) return;
  if (slider._autoplayEnhanced) return;
  slider._autoplayEnhanced = true;

  slider._autoplayTimer = null;
  slider._currentPage = 0;
  slider._pageCount = Math.ceil(sliderItems.length / itemsPerScroll);

  if (!slider.startAutoplay) {
    slider.startAutoplay = function() {
      if (this._autoplayTimer) clearInterval(this._autoplayTimer);
      this._autoplayTimer = setInterval(() => {
        this._currentPage++;
        if (this._currentPage >= this._pageCount) {
          this._currentPage = 0;
          sliderList.style.scrollBehavior = 'smooth';
          sliderList.scrollLeft = 0;
          setTimeout(() => {
            sliderList.style.scrollBehavior = 'auto';
          }, 300);
        } else {
          const nextButton = this.querySelector('.slider-button--next');
          if (nextButton) {
            nextButton.click();
          }
        }
      }, autoplaySpeed);
    };
  }

  if (!slider.stopAutoplay) {
    slider.stopAutoplay = function() {
      if (this._autoplayTimer) {
        clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }
    };
  }
  
  slider.startAutoplay();
}

function initializePopupSliders() {
  const popupCloseButtons = document.querySelectorAll('.popup-close, .popup-close-overlay');
  const popupOpenElements = document.querySelectorAll('[data-popup-target]');

  popupOpenElements.forEach(element => {
    element.addEventListener('click', () => {
      setTimeout(() => {
        const popups = document.querySelectorAll('popup:not([style*="display: none"])');
        popups.forEach(popup => {
          const sliders = popup.querySelectorAll('slider-component');
          sliders.forEach(enhanceSliderWithAutoplay);
        });
      }, 300);
    });
  });

  document.addEventListener('click', event => {
    setTimeout(() => {
      const visiblePopups = document.querySelectorAll('popup:not([style*="display: none"])');
      visiblePopups.forEach(popup => {
        const sliders = popup.querySelectorAll('slider-component');
        sliders.forEach(slider => {
          if (slider.startAutoplay) {
            slider.startAutoplay();
          }
        });
      });
    }, 300);
  });

  popupCloseButtons.forEach(button => {
    button.addEventListener('click', () => {
      const sliders = document.querySelectorAll('slider-component');
      sliders.forEach(slider => {
        if (slider.stopAutoplay) {
          slider.stopAutoplay();
        }
      });
    });
  });
}
